var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nb-switch',{attrs:{"label":_vm.answerBlockData.label,"info":_vm.answerBlockData.info},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }